export default "__VITE_ASSET__CoFfZvlN__"